export const QuoteRegularPrice = '通常価格'
export const QuotePartialPrice = '部分モニター価格'
export const QuoteFullPrice = '顔出しモニター価格'
